import React, { FC, useState } from 'react';
import { Checkbox, Dropdown } from 'antd';
import { Divider } from 'common/components';
import { User } from 'common/svg';
import { getUserRole } from 'entities/User/User.helper';
import { EUserRole } from 'entities/User/User.enum';

interface IComponentProps {
  roles: string[];
  isAccountOwner: boolean;
  isSeller?: boolean;
  onChange: (value: string[]) => void;
}

export const UserCardRoleSelector: FC<IComponentProps> = ({ roles, isAccountOwner, isSeller, onChange }) => {
  const [open, setOpen] = useState<boolean>(false);

  const { isAccountAdmin, isManager, isSellerManager, isHeadOfDepartment } = getUserRole(roles);
  const checkAll = isAccountAdmin && (isSeller ? isSellerManager : isManager && isHeadOfDepartment);

  const onAllChange = (checked: boolean) => {
    const newRoles = [];

    if (checked && isSeller) {
      newRoles.push(EUserRole.AccountAdmin, EUserRole.SellerManager);
    }

    if (checked && !isSeller) {
      newRoles.push(EUserRole.AccountAdmin, EUserRole.Manager, EUserRole.HeadOfDepartment);
    }

    if (!checked && isAccountOwner) {
      newRoles.push(EUserRole.AccountAdmin);
    }

    onChange(newRoles);
  };

  const onRolesChange = (checked: boolean, value: string) => {
    const newRoles = checked ? [...roles, value] : roles.filter((role) => role !== value);

    onChange(newRoles);
  };

  return (
    <Dropdown
      overlayClassName="redesign"
      trigger={['click']}
      placement="bottomLeft"
      onOpenChange={(value) => setOpen(value)}
      dropdownRender={() => {
        return (
          <div className="custom-dropdown" style={{ width: 364 }}>
            <Checkbox className="checkbox-with-description" checked={checkAll} onChange={(e) => onAllChange(e.target.checked)}>
              <div className="checkbox-with-description__label">Все</div>
            </Checkbox>

            <Divider marginY={8} />

            {isSeller ? (
              <>
                <Checkbox
                  className="checkbox-with-description"
                  checked={isSellerManager}
                  onChange={(e) => onRolesChange(e.target.checked, EUserRole.SellerManager)}
                >
                  <div className="checkbox-with-description__label">Менеджер контракта</div>

                  <div className="checkbox-with-description__description">
                    Доступ к заказам и корзинам заявителей. Для завершения настройки привяжите менеджера к нужному контракту в
                    разделе Контракты.
                  </div>
                </Checkbox>

                <Divider marginY={8} />
              </>
            ) : (
              <>
                <Checkbox
                  className="checkbox-with-description"
                  checked={isHeadOfDepartment}
                  onChange={(e) => onRolesChange(e.target.checked, EUserRole.HeadOfDepartment)}
                >
                  <div className="checkbox-with-description__label">Руководитель подразделения</div>

                  <div className="checkbox-with-description__description">
                    Для завершения настройки привяжите сотрудника к нужному подразделению в разделе Подразделения.
                  </div>
                </Checkbox>

                <Divider marginY={8} />

                <Checkbox
                  className="checkbox-with-description"
                  checked={isManager}
                  onChange={(e) => onRolesChange(e.target.checked, EUserRole.Manager)}
                >
                  <div className="checkbox-with-description__label">Закупщик</div>

                  <div className="checkbox-with-description__description">Доступ к управлению заказами сотрудников</div>
                </Checkbox>

                <Divider marginY={8} />
              </>
            )}

            <Checkbox
              className="checkbox-with-description"
              disabled={isAccountOwner}
              checked={isAccountAdmin}
              onChange={(e) => onRolesChange(e.target.checked, EUserRole.AccountAdmin)}
            >
              <div className="checkbox-with-description__label">Администратор аккаунта</div>

              <div className="checkbox-with-description__description">Доступ ко всем функциям системы</div>
            </Checkbox>
          </div>
        );
      }}
    >
      <div className={`flex align-center user-card-role-selector ${open ? 'opened' : ''}`}>
        <div className="mr-3">
          <User className="icon-user-dark-grey" />
        </div>

        <span className="ff-medium fs-xs color-dark-grey">Назначить роль</span>
      </div>
    </Dropdown>
  );
};
